import { ReactElement } from "react";

const ErrorSvg = (): ReactElement => {
  return (
    <svg width="140" height="100" viewBox="0 0 140 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_218_2565)">
        <g filter="url(#filter0_d_218_2565)">
          <path
            d="M94.4306 71.3509L73.1831 35.0919C71.5565 32.3027 67.4514 32.3027 65.8138 35.0919L44.5763 71.3509C42.9416 74.1301 44.9776 77.6265 48.254 77.6265H90.7489C94.0122 77.6265 96.0543 74.1401 94.4306 71.3509ZM67.1068 46.5473C67.1068 45.2275 68.1776 44.1566 69.4975 44.1566C70.8173 44.1566 71.8882 45.2325 71.8882 46.5473V59.2978C71.8882 60.6177 70.8173 61.6885 69.5871 61.6885C68.3569 61.6885 67.1068 60.6226 67.1068 59.2978V46.5473ZM69.4975 71.2513C67.7682 71.2513 66.3656 69.8488 66.3656 68.1195C66.3656 66.3902 67.7672 64.9877 69.4975 64.9877C71.2277 64.9877 72.6293 66.3902 72.6293 68.1195C72.6253 69.8468 71.2307 71.2513 69.4975 71.2513Z"
            fill="url(#paint0_linear_218_2565)"
          />
        </g>
      </g>
      <rect x="1" y="1" width="138" height="98" stroke="white" strokeWidth="2" strokeDasharray="4 4" />
      <defs>
        <filter
          id="filter0_d_218_2565"
          x="24"
          y="17"
          width="91"
          height="84.6265"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="10" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.9625 0 0 0 0 0.172448 0 0 0 0 0.362061 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_218_2565" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_218_2565" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_218_2565"
          x1="44"
          y1="77.6265"
          x2="99.9044"
          y2="40.3566"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3B57" />
          <stop offset="1" stopColor="#892168" />
        </linearGradient>
        <clipPath id="clip0_218_2565">
          <rect width="140" height="100" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ErrorSvg;
